import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SelectPackage = ({ packages, selectedPackage, setSelectedPackage }) => {
  const search = useLocation().search;
  const urlParams = new URLSearchParams(search);
  const pkg = ( urlParams.has("pkg") && urlParams.get("pkg") !== "") ? urlParams.get("pkg") : "ultimate";
  useEffect(() => {
    setSelectedPackage(pkg);
  }, [pkg, setSelectedPackage])
  const handleChange = (e) => {
    setSelectedPackage(e.target.value);
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      {packages === null ? (
        <Box sx={{ textAlign: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ minWidth: 220, maxWidth: 400 }}>
          <FormControl fullWidth variant="outlined" color="info">
            <InputLabel id="select-package">Select your package</InputLabel>
            <Select
              labelId="select-package"
              id="select-package"
              value={selectedPackage}
              label="Select your package"
              onChange={handleChange}
            >
              <MenuItem disabled>Primary Packages</MenuItem>
              {packages?.slice(0, 4).map((packageType, index) => (
                <MenuItem
                  sx={{ pl: 4, "&:hover": {backgroundColor: "#ff6600"} }}
                  key={index}
                  value={packageType?.name}
                >
                  {packageType?.title}
                </MenuItem>
              ))}
              <MenuItem disabled>Add-On Packages</MenuItem>
              {packages?.slice(4,8).map((packageType, index) => (
                <MenuItem
                  sx={{
                    pl: 4,
                    "&:hover": {backgroundColor: "#ff6600"}
                  }}
                  key={index}
                  value={packageType?.name}
                >
                  {packageType?.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
};

export default SelectPackage;
